"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _theme = require("../theme");
var _classnames = _interopRequireDefault(require("classnames"));
require("./global-subnav.css");
var _excluded = ["tagName", "className", "active"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * A subnav element intended to be used in tandem with GlobalNav. It does not follow the crate system, but takes up the full width of the browser at all times.
 * GlobalSubnav has support for themes and for styling over the default background colors and borders.
 */
var GlobalSubnav = function GlobalSubnav(_ref) {
  var items = _ref.items,
    className = _ref.className,
    ariaLabel = _ref.ariaLabel;
  return /*#__PURE__*/_react["default"].createElement(_theme.ThemeContext.Consumer, null, function (theme) {
    var themeDark = theme === _theme.themes.dark;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('sb-global-gutters sb-global-gutters--logoOffset', _defineProperty({
        'sb-global-subnav-containerLight': !themeDark,
        'sb-global-subnav-containerDark': themeDark
      }, className, Boolean(className)))
    }, /*#__PURE__*/_react["default"].createElement("nav", {
      "aria-label": ariaLabel
    }, /*#__PURE__*/_react["default"].createElement("ul", {
      className: "sb-global-subnav-list flex-shrink-none"
    }, items.map(function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$tagName = _ref2.tagName,
        TagName = _ref2$tagName === void 0 ? 'a' : _ref2$tagName,
        itemClassName = _ref2.className,
        active = _ref2.active,
        item = _objectWithoutProperties(_ref2, _excluded);
      var i = arguments.length > 1 ? arguments[1] : undefined;
      if (!item.children) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: i
      }, /*#__PURE__*/_react["default"].createElement(TagName, _extends({}, item, {
        "aria-current": active ? 'page' : null,
        className: (0, _classnames["default"])('sb-global-subnav-item', _defineProperty({
          'sb-global-subnav-item--active': active,
          'color-textWhite': themeDark
        }, itemClassName, Boolean(itemClassName)))
      })));
    }))));
  });
};
GlobalSubnav.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `aria-label` applied to root <nav> element.
   */
  ariaLabel: _propTypes["default"].string.isRequired,
  /**
   * An array of nav item props objects. Passes any unrecognized props
   * along to the rendered links, allowing you to include event handlers, DOM attributes,
   * children, and more.
   */
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    /**
     * Flag to apply when a user is on the page matching this nav item.
     * Adds an underline and adjusted text styles to active items.
     */
    active: _propTypes["default"].bool,
    /**
     * Content for each list item, can be a string or a component.
     */
    children: _propTypes["default"].any.isRequired,
    /**
     * HTML element or React component to use for this item. Defaults to `a`.
     */
    tagName: _propTypes["default"].any
  })),
  /**
   * ClassName will overwrite the container's background and border styling.
   */
  className: _propTypes["default"].string
} : {};
GlobalSubnav.displayName = 'GlobalSubnav';
var _default = exports["default"] = GlobalSubnav;